import NavigationSection from "@/components/NavigationSection";
import { ROUTES } from "@/config/routes";
import { Box } from "@chakra-ui/react";
import { ShieldCheck } from "lucide-react";
import { useProtectMerchant } from "./useProtectMerchant";

type Props = { showText: boolean };

const ProtectMenuSection = ({ showText }: Props): JSX.Element | null => {
  const { protectMerchant } = useProtectMerchant();
  if (!protectMerchant) return null;

  return (
    <>
      <Box
        px={3}
        pt={3}
        fontSize="xs"
        fontWeight={600}
        letterSpacing="wider"
        textTransform="uppercase"
        color="gray.500"
        whiteSpace="nowrap"
        overflow="hidden"
        height={showText ? "auto" : "0px"}
        opacity={showText ? 1 : 0}
        transition="all 0.3s ease-in-out"
      >
        Fianza
      </Box>
      <NavigationSection
        path={ROUTES.DASHBOARD.PROTECT}
        section="Protect"
        showText={showText}
        icon={ShieldCheck}
        tag="Nuevo"
      />
    </>
  );
};

export default ProtectMenuSection;
